export default "__VITE_ASSET__DOT9YLsZ__"